import { makeStyles } from '@material-ui/core';



export const paginationStyles = makeStyles((theme) => ({
    paginationContainer: {
        '& .pagination': {
            '&-inner': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
            '&-text': {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
            },
        },
    },

}));



